// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8202) return "static/chunks/8202-fe4bcc71cbbe326b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "745e004b217d8b7d" + ".js";
};